
const SubmitPage2 = ({ handleSubmit, handleBack, formData }) => {


    return (
        <div
            className="bg-[#e9ecef] flex items-center justify-center min-h-screen"
            style={{
                backgroundColor: "#fff",
                backgroundImage:
                    "radial-gradient(rgba(183, 228, 199,1) 10%, transparent 10%)",
                backgroundPosition: "0% 0%",
                backgroundSize: "1rem 1rem"
            }}
        >
            <div className="bg-white rounded-lg drop-shadow-2xl px-8 py-10 w-full max-w-[1000px]">
                {/* Icon and Heading */}


                {/* Left-aligned details */}
                <div className="flex flex-col gap-4 text-left">

                    <p className="">
                        Your Initial Application Has Been Submitted,
                    </p>

                    <p>
                        <strong className="text-red-500 underline"> Selected applicants will be contacted only </strong> to continue on their application form and
                        complete the needed fees payment.
                    </p>

                    <p>
                        <strong className="text-red-500 underline">Please Note:</strong> No application is considered a formal application without
                        payment of application and admission tests/placement test fees. Payment of application
                        fees and admission tests/placement test fees <strong className="text-red-500 underline">does not mean</strong>  admission or acceptance into
                        the University.
                    </p>


                    <p className="text-center rtl text-base leading-relaxed">
                        انا____ <strong className="text-red-500" >{formData.arabicFirstName?.value}</strong>____ بطاقة المدنية رقم___<strong className="text-red-500" >{formData.civilId?.value}</strong>___اقر و اوافق على جميع الشروط والاحكام المذكورة اعلاه

                    </p>

                </div>

                {/* Buttons */}
                <div className="mt-4 flex justify-between pt-4">
                    <button
                        onClick={handleBack}
                        className="bg-gray-300 text-gray-800 font-bold px-8 py-3 rounded-lg"
                        type="button"
                    >
                        Back
                    </button>
                    <button
                        onClick={handleSubmit}
                        className={`font-bold px-10 py-3 rounded-lg ${"bg-[#b60041] text-white"

                            }`}

                        type="button"
                    >
                        Agree & Submit
                    </button>
                </div>
            </div>
        </div>

    );
};

export default SubmitPage2;


